import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { ru } from 'date-fns/locale'
import { useTranslation } from 'react-i18next'

const isValidDate = (value) =>
  value instanceof Date && !Number.isNaN(value.getTime())

/**
 * Компонент диалога для экспорта данных URV
 */
const ExportDialog = ({
  open,
  onClose,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  onExport,
  isExporting
}) => {
  const { t } = useTranslation()

  const handleStartDateChange = (value) => {
    if (isValidDate(value)) {
      setStartDate(value)
    }
  }

  const handleEndDateChange = (value) => {
    if (isValidDate(value)) {
      setEndDate(value)
    }
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('select_the_report_period')}</DialogTitle>
      <DialogContent>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ru}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
            <DatePicker
              label={t('start_date')}
              value={startDate}
              onChange={handleStartDateChange}
              format="dd/MM/yyyy"
              maxDate={endDate}
              slotProps={{
                textField: { fullWidth: true }
              }}
            />
            <DatePicker
              label={t('end_date')}
              value={endDate}
              onChange={handleEndDateChange}
              format="dd/MM/yyyy"
              minDate={startDate}
              slotProps={{
                textField: { fullWidth: true }
              }}
            />
          </Box>
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <Button variant="contained" onClick={onExport} disabled={isExporting}>
          {isExporting ? t('exporting') : t('acknowledge')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ExportDialog
